import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RepositoryHomeComponent } from './repository-home/repository-home.component';
import { RepositoryComponent } from './repository-report/repository.component';
import { ReportDetailsComponent } from './report-details/report-details.component';
import { FileViewerComponent } from './file-viewer/file-viewer.component';
import { TableExtractionComponent } from './table-extraction/table-extraction.component';
import { AllFileListComponent } from './all-file-list/all-file-list.component';

const routes: Routes = [
  // { path: 'topline', loadChildren: () => import('./../topline/topline.module').then(m => m.ToplineModule) },
  {
    path:'',
    component:RepositoryHomeComponent,
    children:[
      {path:'',component:RepositoryComponent},
      {path:'all-files', component: AllFileListComponent},
      { path: 'report/:id', component: RepositoryComponent },
      { path: 'details/:uuid', component: ReportDetailsComponent },
      { path: 'table-extraction/:uuid', component:TableExtractionComponent},

      { path: 'file-view', component: FileViewerComponent },
      { path: 'file-view/:uuid', component: FileViewerComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RepositoryRoutingModule { }
